import { Icon } from "@/components/common/Icon";
import type { AttachmentControl } from "@/lib/message-controls";

interface AttachmentBlockProps {
	control: AttachmentControl;
}

/** メッセージ本文に埋め込まれた添付ファイルの第一級UI表示。 */
export function AttachmentBlock({ control }: AttachmentBlockProps) {
	const href = `/api/uploads/file/${encodeURIComponent(control.file_id)}`;
	return (
		<a
			data-testid="attachment-block"
			href={href}
			download={control.file_name}
			style={{
				display: "inline-flex",
				alignItems: "center",
				gap: 2,
				padding: "4px 10px",
				marginTop: 6,
				fontSize: "var(--text-caption)",
				lineHeight: "var(--leading-none)",
				color: "var(--fg-1)",
				background: "var(--surface-2)",
				borderRadius: "var(--radius-full)",
				boxShadow: "var(--shadow-ring)",
				textDecoration: "none",
				maxWidth: "100%",
				userSelect: "none",
			}}
		>
			<Icon name="paperclip" size={14} color="var(--fg-3)" />
			<span
				style={{
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				}}
			>
				{control.file_name}
			</span>
		</a>
	);
}
